import data from "../data/java.json";


const javaQuiz = data.java;

export {javaQuiz};